import React from 'react';

const About = () => {
  return (
    <div>
      <h1>About This App</h1>
      <p>Application for searching Github users</p>
      <p>Version 1.0.0</p>
    </div>
  );
};

export default About;